import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { validate as validateUuid } from 'uuid';

import useGetRouteHash from 'hooks/get-route-hash.hooks';

export const useSessionUuidParamAdmin = () => {
	const { session } = useParams<{ session: string }>();
	const hash = useGetRouteHash();

	return useMemo(() => {

		/* hash check is for platform app iframe rendering */
		if (hash) {
			const regex = /#path=\/session\/(.+?)(?:__|$)/;
			const hashSessionUuid = hash.match(regex)?.[1];
			if (hashSessionUuid && validateUuid(hashSessionUuid)) {
				return hashSessionUuid;
			}
		}

		return session;
	}, [hash, session]);
};

export const useSessionUuid = () => {
	const { sessionUuid } = useParams<{ sessionUuid: string }>();
	return useMemo(() => sessionUuid, [sessionUuid]);
};

export const useSessionUuidParamModerator = () => {
	const { session_uuid } = useParams<{ session_uuid: string }>();
	return useMemo(() => session_uuid, [session_uuid]);
};
